import { createAsyncThunk } from "@reduxjs/toolkit";
import { setWidgetSetup } from "../../../../dashboardsSlice";
import { billingExplorerWidgetSetupSelector } from "../../../../selectors/setups/billing-explorer/billingExplorerWidgetSetupSelector";
import { billingExplorerWidgetSetupDefaultData } from "../../../../utils/constants/billingExplorerWidgetSetupDefaultData";
import { getBillingExplorerWidgetSetupDataThunk } from "../getBillingExplorerWidgetSetupDataThunk";
import { ChartType } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";

export const billingExplorerViewTypeChangeThunk = createAsyncThunk(
  "dashboards/billingExplorerWidgetViewTypeChange",
  async (newChartType: ChartType, { dispatch, getState }) => {
    const state = getState() as RootState;
    const existingSetup = billingExplorerWidgetSetupSelector(state);
    const currentVisualization = existingSetup?.visualization;
    const defaultVisualization =
      billingExplorerWidgetSetupDefaultData.visualization;

    const oldChartType = currentVisualization?.chart_type;

    const resetPercent = !(
      chartTypesWithPercent.includes(oldChartType ?? "") &&
      chartTypesWithPercent.includes(newChartType)
    );

    const resetForecastCumulativeLine = !(
      chartTypeWithForecastCumulativeLine.includes(oldChartType ?? "") &&
      chartTypeWithForecastCumulativeLine.includes(newChartType)
    );

    if (!existingSetup || !currentVisualization) {
      return;
    }

    dispatch(
      setWidgetSetup({
        ...existingSetup,
        viewType: newChartType,
        visualization: {
          chart_type: newChartType,
          scale: currentVisualization.scale,
          show_legends: currentVisualization.show_legends,
          show_data_labels: currentVisualization.show_data_labels,
          series: currentVisualization.series,

          chart_base_type: resetPercent
            ? defaultVisualization.chart_base_type
            : currentVisualization.chart_base_type,
          display_forecast: resetForecastCumulativeLine
            ? defaultVisualization.display_forecast
            : currentVisualization.display_forecast,
          cumulative_line: resetForecastCumulativeLine
            ? defaultVisualization.cumulative_line
            : currentVisualization.cumulative_line,

          //table, numeral settings
          trend: currentVisualization.trend,
          forecasted_cost: currentVisualization.forecasted_cost,
          previous_period_cost: currentVisualization.previous_period_cost,
          account_column: currentVisualization.account_column,
          region_column: currentVisualization.region_column,
        },
        frequency: newChartType === "pie" ? "monthly" : existingSetup.frequency,
      }),
    );
    dispatch(getBillingExplorerWidgetSetupDataThunk());
  },
);

const chartTypesWithPercent = ["stacked_column", "column"];
const chartTypeWithForecastCumulativeLine = [
  "stacked_column",
  "column",
  "line",
];
